
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '../controlador';
    import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';
    import { Wait, WaitEntre } from '@/__env/ext';
    import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;

        @Prop()
        public Publicacion: Publicacion;

        public Observaciones: Pregunta[] = [];
        public Cargando: boolean = false;

        public Enviando: boolean = false;
        public Observacion: string = '';
        async Enviar()
        {

        }

        async mounted()
        {
            this.Observaciones.clear();
            this.Cargando = true;
            await WaitEntre( 50, 100 );
            //let e = await Pregunta.find( { publicacion: this.Publicacion.Id } );
            //if ( e.Items.hasRows() )
            //{
            //    this.Observaciones = e.Items;
            //}
            this.Cargando = false;
        }
    }
